import React, { Component } from 'react'
import Link from '../utils/link'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { Car, Bed, Bath } from './icons'

class BedBathCar extends Component {

  render() {

    let { color, beds, baths, carports, openSpaces, garages } = this.props

    let parking = ( carports > 0 ? carports : 0 ) + ( garages > 0 ? garages : 0 ) + ( openSpaces > 0 ? openSpaces : 0 )

    return (
      <>

        { ( beds > 0 || baths > 0 || carports > 0 ) &&

          <section className='bed-bath-car'>

            <div className='bed-bath-car__inner'>

              <div className='bed-bath-car__content'>

                <div className='bed-bath-car__list'>

                  <ul>
                    { beds > 0 && <li><Bed color={color} /><span>{ beds }</span></li> }
                    { baths > 0 && <li><Bath color={color} /><span>{ baths }</span></li> }
                    { parking > 0 && <li><Car color={color} /><span>{ parking }</span></li> }
                  </ul>
                
                </div>

              </div>

            </div>

          </section>

        } 

      </>
    )
  }
}

export default BedBathCar
